// extracted by mini-css-extract-plugin
export default {"imageCreativeDetailContainer":"imageCreativeDetail_imageCreativeDetailContainer__CJb2X","imageCreativeDetail":"imageCreativeDetail_imageCreativeDetail__te2lI"};